export const hasValue = (value) => {
    if (value === "" || value === null || value === undefined) {
        return false;
    }
    return true;
}

export const ProcessAPIError = (error) => {
    if (hasValue(error?.response?.data?.error)) {
        return error.response.data.error;
    }
    return "There is some error processing your request. Please try after some time";
}

export const CreateLoginSession = (device) => {
    sessionStorage.clear();
    localStorage.clear();

    let session = {
        device_id : device.id,
        name: device?.name,
        account_id: device.accountId,
        profile_pic: device?.profilePicture,
        email: device?.recoveryEmail
    }

    localStorage.setItem('auth', JSON.stringify(session))
}

export const isAuthenticated = () => {
    if (localStorage) {
        if (hasValue(localStorage.getItem('auth')) && localStorage.getItem('auth') !== "null") {
            let obj = JSON.parse(localStorage.getItem('auth'));
            if (hasValue(obj?.device_id)) {
                return true;
            }
        }
    }
    return false;
}

export const LogOut = () => {
    sessionStorage.clear();
    localStorage.clear();
}